<template>
    <span>
        <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
                <path
                    d="M11.556 29.087a2.579 2.579 0 0 1-4.082-1.69 5.799 5.799 0 0 0-4.87-4.871 2.579 2.579 0 0 1-1.691-4.082 5.799 5.799 0 0 0 0-6.888 2.579 2.579 0 0 1 1.69-4.082 5.799 5.799 0 0 0 4.871-4.87A2.579 2.579 0 0 1 11.556.913a5.799 5.799 0 0 0 6.888 0 2.579 2.579 0 0 1 4.082 1.69 5.799 5.799 0 0 0 4.87 4.871 2.579 2.579 0 0 1 1.691 4.082 5.799 5.799 0 0 0 0 6.888 2.579 2.579 0 0 1-1.69 4.082 5.799 5.799 0 0 0-4.871 4.87 2.579 2.579 0 0 1-4.082 1.691 5.799 5.799 0 0 0-6.888 0z"
                    fill="#E75300"
                />
                <path
                    d="M10.76 18.905c-1.84-.213-2.216-2.225-1.405-4.601.837-2.493 3.176-5.74 5.198-5.396 1.336.232 1.846 1.895 2.22 3.056.155.524.375 1.364.362 1.537-.012.144-.123.34-.214.48-2.098 3.177-4.545 5.125-6.162 4.924m10.407-1.762c-.127-.375-.315-.888-.67-1.95-.101-.318-.187-.618-.288-.96.156-.242.348-.52.523-.784C22 11.507 23.503 9.18 24.33 7.93h-3.401c-.474.715-1.162 1.75-1.85 2.796-.565-1.853-1.976-3.075-3.926-3.212-2.603-.188-7.092 1.73-8.761 6.517-1.544 4.432 1.8 6.327 4.358 6.459 2.533.125 5.547-.999 7.574-3.516.078.242.169.54.25.77.488 1.526 1.447 2.452 3.057 2.646 2.058.25 3.315-1.331 3.315-1.331-1.899.206-3.123-.041-3.78-1.915"
                    fill="#FFF"
                />
            </g>
        </svg>
    </span>
</template>
<script>
export default {
	name: 'IconAlphaVerify',
	props: {
		height: {
			type: Number,
			default: 32,
		},
		width: {
			type: Number,
			default: 32,
		},
	},
};
</script>